const EmittedAndReceivedConfronta = () => import('@/components/emittedAndReceived/Confronta.vue')
const EmittedAndReceivedReception = () => import('@/components/emittedAndReceived/Reception.vue')

const emittedReceivedPermissions = [
  'confronta_emitidos_recibidos',
  'recepcion_pagos'
]

export const emittedReceivedRoutes = [
  {
    path: '/emitted-and-received',
    meta: { breadcrumb: 'Emitidos y Recibidos', requiresAuth: true, permissions: emittedReceivedPermissions },
    children: [
      { path: 'confronta', component: EmittedAndReceivedConfronta, meta: { breadcrumb: 'Confronta', permissions: [emittedReceivedPermissions[0]]} },
      { path: 'reception', component: EmittedAndReceivedReception, meta: { breadcrumb: 'Recepción de Pagos', permissions: [emittedReceivedPermissions[1]] } },
    ],
  },
]
